import React from 'react';
import { Clock } from 'lucide-react';
interface HeroSectionProps {
  timeLeft: string;
  price: string;
}
export function HeroSection({
  timeLeft,
  price
}: HeroSectionProps) {
  return <section className="relative min-h-screen flex flex-col items-center justify-center bg-[#0a0a0a] text-[#e5e5e5] pt-12 pb-20 px-4 overflow-hidden border-b border-[#333]" data-id="element-34">
      {/* Background elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(200,184,154,0.08)_0%,_rgba(10,10,10,1)_70%)] pointer-events-none" data-id="element-35" />

      <div className="relative z-10 max-w-5xl mx-auto w-full flex flex-col items-center text-center space-y-8" data-id="element-36">
        {/* Top Badge */}
        <div className="inline-block border border-[#cc2200] bg-[#cc2200]/10 px-4 py-1 rounded-sm mb-4" data-id="element-37">
          <p className="text-[#cc2200] font-mono text-xs md:text-sm tracking-widest uppercase font-bold" data-id="element-38">
            DE LA OFICINA DE: INVESTIGACIÓN CRIMINAL ESPECIAL
          </p>
        </div>

        {/* Main Headline */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight tracking-tighter text-[#c8b89a] drop-shadow-lg font-['Special_Elite']" data-id="element-39">
          ¿CREES QUE ERES MÁS LISTO QUE UN ASESINO?
        </h1>

        {/* Subheadline */}
        <p className="text-xl md:text-2xl text-gray-400 font-['Special_Elite'] max-w-3xl" data-id="element-40">
          Aquí tienes 4 expedientes que dicen que no.
        </p>

        {/* Product Image */}
        <div className="relative w-full max-w-4xl my-8 group" data-id="element-41">
          <div className="absolute -inset-1 bg-gradient-to-r from-[#cc2200] to-[#c8b89a] rounded-lg blur opacity-20 group-hover:opacity-40 transition duration-1000" data-id="element-42"></div>
          <img src="https://cdn.magicpatterns.com/uploads/8k5j4misK7CyTskxzyKHmw/heylloyd-image-1771733028026.png" alt="Pack 4x1 Juegos de Investigación Criminal" className="relative rounded-lg shadow-2xl border border-[#333] w-full object-cover" data-id="element-43" />
        </div>

        {/* Body Copy */}
        <p className="text-lg md:text-xl text-gray-300 max-w-2xl leading-relaxed" data-id="element-44">
          Deja de ser un espectador pasivo. Convierte tu sala en una unidad de
          homicidios y resuelve los 4 casos que están obsesionando a internet.
        </p>

        {/* Urgency Bar */}
        <div className="w-full max-w-2xl bg-[#1a1a1a] border border-[#c8b89a]/40 text-[#c8b89a] py-3 px-6 rounded-sm shadow-lg flex items-center justify-center gap-3 animate-pulse" data-id="element-45">
          <Clock className="w-5 h-5" data-id="element-46" />
          <span className="font-bold font-mono tracking-wider" data-id="element-47">
            OFERTA 4X1 EXPIRA EN: {timeLeft}
          </span>
        </div>

        {/* CTA Button */}
        <div className="flex flex-col items-center gap-3 w-full" data-id="element-48">
          <a href="#oferta" className="w-full max-w-md bg-[#cc2200] hover:bg-[#aa1100] text-white text-xl md:text-2xl font-bold py-6 px-8 rounded-sm shadow-[0_0_20px_rgba(204,34,0,0.4)] transition-all transform hover:scale-105 border-2 border-[#ff4422] uppercase font-['Special_Elite'] text-center block" data-id="element-49">
            ¡SÍ! QUIERO MIS 4 EXPEDIENTES AHORA — {price}
          </a>
          <p className="text-sm text-gray-500 font-mono" data-id="element-50">
            Descarga inmediata en PDF · Compatible con Tablet, Móvil u Ordenador
          </p>
        </div>
      </div>
    </section>;
}